import { render, staticRenderFns } from "./DashboardManagement.vue?vue&type=template&id=d65eb54e&scoped=true&"
import script from "./DashboardManagement.vue?vue&type=script&lang=js&"
export * from "./DashboardManagement.vue?vue&type=script&lang=js&"
import style0 from "./DashboardManagement.vue?vue&type=style&index=0&id=d65eb54e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65eb54e",
  null
  
)

export default component.exports